import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { dictionaryEntityFieldTypes } from '@/constants/fields';
import ToggleCell from '@/components/table/ToggleCell';
import {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldEntityTableCell = ({
  code,
  category,
  entity,
  type,
  dictionaryUUID,
  fieldUUID,
  fieldName,
  canEdit,
  template,
  updateProperties,
}) => {
  if (!Object.values(dictionaryEntityFieldTypes).includes(type)) {
    return (<Table.Cell />);
  }

  return (
    <ToggleCell
      checked={entity}
      disabled={!canEdit}
      label={fieldName}
      onClick={() => updateProperties(category, code, dictionaryUUID, { entity: !entity }, fieldUUID, template)}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldEntityTableCell);
